import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';

import { negocio } from '../../conexiones';
import IEtapas from './entidades/etapas';

class ModeloEtapas {
    public consultarEtapas() {
        return manejadorRest<IRespuesta<IEtapas>>(() => negocio.get('Etapas/ConsultarListaEtapas'));
    }

    public ConsultarListaEtapasPorFiltro(etapas: Partial<IEtapas>) {
        return manejadorRest<IRespuesta<IEtapas>>(() => negocio.post('Etapas/ConsultarListaEtapasPorFiltro', etapas));
    }

    public crearEtapas(etapas: IEtapas) {
        return manejadorRest<IRespuesta<IEtapas>>(() => negocio.post('Etapas/GuardarEtapas', etapas));
    }     

    public editarEtapas(etapas: IEtapas) {
        return manejadorRest<IRespuesta<IEtapas>>(() => negocio.put('Etapas/EditarEtapas', etapas));
    }

    public eliminarEtapas(etapas: IEtapas) {
        return manejadorRest<IRespuesta<IEtapas>>(() => negocio.delete('Etapas/EliminarEtapas', etapas));
    }
}

export default ModeloEtapas;
